Meteor.publish('bands', function(){
  return Bands.find({contactPerson: this.userId}, {sort: {name: 1}});
});

Meteor.publish('allBands', function(){
  if ( Roles.userIsInRole( this.userId, 'admin') ) {
    return Bands.find({}, {sort: {name: 1}});
  } else {
    this.stop();
    return
  }
});

Meteor.publish('singleBand', function(id){
  return Bands.find({_id:  id});
});

Meteor.publish('images', function(){
  return Images.find({});
});

